import { useIntl } from "react-intl";

import { ConfirmDrawer } from "@/components/ConfirmDrawer/ConfirmDrawer";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function TravellerCloseConfirmDrawer({
  open,
  onClose,
  onConfirm,
}: Props) {
  const intl = useIntl();

  return (
    <ConfirmDrawer
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={intl.formatMessage({ id: "travellers.closeConfirmation.title" })}
      description={intl.formatMessage({
        id: "travellers.closeConfirmation.description",
      })}
      closeLabel={intl.formatMessage({ id: "back" })}
      confirmLabel={intl.formatMessage({
        id: "travellers.closeConfirmation.leave",
      })}
    />
  );
}
